/**
 * Unique display names from schedule licensed guides (exc_schedule_licensed_guides / API `licensed_guides`).
 */
export function collectLicensedGuideNames(schedules) {
  if (!Array.isArray(schedules)) return [];
  const seen = new Map();
  for (const s of schedules) {
    const guides = s?.licensed_guides;
    if (!Array.isArray(guides) || guides.length === 0) continue;
    for (const g of guides) {
      const name = String(g?.name ?? '').trim();
      if (!name) continue;
      const key = name.toLowerCase();
      if (!seen.has(key)) seen.set(key, name);
    }
  }
  return Array.from(seen.values()).sort((a, b) =>
    a.localeCompare(b, undefined, { sensitivity: 'base' })
  );
}
